import React from 'react';

const Grass = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100'
      className='icon'
      version='1.1'
      viewBox='0 0 120 120'
    >
      <g transform='translate(87.163 -58.826)'>
        <path
          fill='#003f12'
          fillOpacity='1'
          stroke='#000'
          strokeLinecap='butt'
          strokeLinejoin='miter'
          strokeOpacity='1'
          strokeWidth='0.261'
          d='M-71.827 59.04c-1.028.034.048 1.363 1.262 2.401 10.92 10.961 18.997 24.72 23.509 39.54 2.564 9.853 4.858 19.783 6.629 29.812 2.962 15.483 3.523 31.264 4.082 46.978l17.684-.003c-.046-16.048-1.68-32.146-5.34-47.78-2.17-9.998-5.61-19.647-9.829-28.943-4.664-9.589-10.69-18.513-17.373-26.796-5.243-6.025-11.483-11.515-18.822-14.752-.883-.335-1.46-.468-1.802-.457zM15.396 82.73a4.71 4.71 0 00-.704.082C9.495 83.845 4.53 86.42.962 90.401c-4.383 4.234-8.43 8.891-11.343 14.284-2.857 4.594-5.047 9.564-6.93 14.63l5.493 23.052c1.154-6.966 1.927-14.041 4.168-20.772 2.104-6.71 4.962-13.159 8.125-19.427 3.413-6.104 7.581-11.81 12.766-16.517.716-.892 3.893-2.96 2.155-2.922zm-101.538 17.57c-.62-.018-1.025.215-.973.876 6.21 8.416 12.691 16.776 16.9 26.445 3.098 7.744 5.811 15.676 7.553 23.848 2.003 8.593 1.942 17.451 2.487 26.207l17.493.018c.14-11.684-2.035-23.353-6.202-34.25-2.26-6.568-5.809-12.592-9.817-18.217-6.36-8.81-13.685-17.106-22.834-23.067-.845-.574-3.244-1.823-4.607-1.86zm117.69.27c-4.446.201-7.929 3.512-11.283 6.106-5.857 5.165-10.826 11.32-14.46 18.258-4.76 8.276-8.755 17.064-11.304 26.287-2.034 8.712-3.782 17.572-3.652 26.562l17.84-.018c.478-8.277-.267-16.636 1.157-24.852 1.303-8.593 3.86-16.947 6.915-25.06 4.001-9.566 8.79-18.819 14.787-27.283z'
        ></path>
      </g>
    </svg>
  );
};

export default Grass;
